import { useContext } from 'react';

import { DialogContext } from '../contexts/DialogContext';

export default () => useContext(DialogContext);
